import {
    ADD_SHIPPING_RATE_FAIL,
    ADD_SHIPPING_RATE_SUCCESS,
    DELETE_SHIPPING_RATE_FAIL,
    DELETE_SHIPPING_RATE_SUCCESS,
    EXPORT_SHIPPING_RATE_FAIL,
    EXPORT_SHIPPING_RATE_SUCCESS,
    GET_SHIPPING_RATE_DETAILS_FAIL,
    GET_SHIPPING_RATE_DETAILS_SUCCESS,
    GET_SHIPPING_RATE_LISTING_FAIL,
    GET_SHIPPING_RATE_LISTING_SUCCESS,
    RESET_SHIPPING_RATE_ATTACHMENT_STATE,
    RESET_SHIPPING_RATE_STATE,
    UPDATE_SHIPPING_RATE_FAIL,
    UPDATE_SHIPPING_RATE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    shippingRateListing: [],
    shippingRateDetails: [],
    addShippingRate: [],
    updateShippingRate: [],
    deleteShippingRate: [],
    exportShippingRate: [],
    error: [],
}

const ShippingRate = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SHIPPING_RATE_LISTING_SUCCESS:
            return {
                ...state,
                shippingRateListing: action.payload
            }
        case GET_SHIPPING_RATE_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SHIPPING_RATE_DETAILS_SUCCESS:
            return {
                ...state,
                shippingRateDetails: action.payload
            }
        case GET_SHIPPING_RATE_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_SHIPPING_RATE_SUCCESS:
            return {
                ...state,
                addShippingRate: action.payload
            }
        case ADD_SHIPPING_RATE_FAIL:
            return {
                ...state,
                error: action.payload,
                addShippingRate: action.payload
            }

        case UPDATE_SHIPPING_RATE_SUCCESS:
            return {
                ...state,
                updateShippingRate: action.payload
            }
        case UPDATE_SHIPPING_RATE_FAIL:
            return {
                ...state,
                error: action.payload,
                updateShippingRate: action.payload,
            }

        case DELETE_SHIPPING_RATE_SUCCESS:
            return {
                ...state,
                deleteShippingRate: action.payload
            }
        case DELETE_SHIPPING_RATE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_SHIPPING_RATE_SUCCESS:
            return {
                ...state,
                exportShippingRate: action.payload
            }
        case EXPORT_SHIPPING_RATE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SHIPPING_RATE_STATE:
            return {
                ...state,
                shippingRateListing: [],
                shippingRateDetails: [],
                addShippingRate: [],
                updateShippingRate: [],
                deleteShippingRate: [],
                exportShippingRate: [],
                error: [],
            }
        case RESET_SHIPPING_RATE_ATTACHMENT_STATE:
            return {
                ...state,
                exportShippingRate: [],
                error: [],
            }
        default:
            return state
    }
}

export default ShippingRate
